export const homeUrl = '/home';